import { styles, variants, BadgeTheme } from '../BadgeStyles.css';
import { baseTheme } from './BadgeThemeBaseTheme.css';
import { multiVariantStyles } from './BadgeVariants.css';

/*******************
 * Component Theme
 *******************/

const BadgeStableTheme: BadgeTheme = {
  baseTheme,
  multiVariantStyles,
  variants,
  styles
};

/*******************
 * Exports
 *******************/

export { BadgeStableTheme };
